import { render, staticRenderFns } from "./FreeTimeForeignPC.vue?vue&type=template&id=98411d80&"
import script from "./FreeTimeForeignPC.vue?vue&type=script&lang=js&"
export * from "./FreeTimeForeignPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports